<template>
  <div class="row"> 
     <div
          v-for="index in showTextReply"
          :key="index"
          class="col-md-12"
        >
          <div class="form-group form-focus select-focus"> 
            <select
              v-model="formParam.buttons[index - 1]"
              class="form-control selectTextReply"  @change="(val) => checkAdd(val,index)"
            >
              <option :value="''">-- Select --</option>
              <template
                v-for="(row, idxBtn) in textReplyRows"
              >
                <option
                  :disabled="selectedReplyID.includes(row.id)"
                  :ref="'text_reply_' + row.id"
                  :key="idxBtn"
                  :value="{ id: row.id, button_text: row.button_text || row.title || '' }"
                >
                  {{ row.button_text || row.title }}
                </option>
              </template>
              <option
                v-if="isUnknownSelected(index)"
                :value="formParam.buttons[index - 1]"
              >
                {{ unknownButtonLabel(index) }}
              </option>
              <option disabled>────────────</option>

                <!-- opsi untuk membuka offcanvas -->
                <option value="__addNew">
                  <span><i class="fa fa-plus"></i>Tambah Text Reply Baru</span>
                </option>
            </select>
            <label class="focus-label"
              >Text Reply {{ index }}</label
            >
          </div>
        </div>
    <div class="col-md-12" v-if="textReplyLoading">
      <small class="text-muted">
        <i class="fa fa-spinner fa-spin"></i> Memuat daftar Text Reply...
      </small>
    </div>
    <div class="col-md-12" v-else-if="textReplyLoadError">
      <small class="text-danger">
        <i class="fa fa-exclamation-triangle"></i>
        Daftar Text Reply gagal dimuat. Tombol tersimpan tetap dipertahankan.
      </small>
    </div>
    <div class="col-md-12" v-else-if="hasUnknownSelected">
      <small class="text-warning">
        <i class="fa fa-exclamation-triangle"></i>
        Sebagian tombol tersimpan tidak ditemukan pada daftar Text Reply.
        Tombol tetap dipertahankan saat disimpan.
      </small>
    </div>
    <div class="col-md-12 text-center">
      <button
        type="button"
        v-if="showTextReply !== 10"
        class="w-100 btn btn-primary btn-sm"
        @click="showTextReply++"
      >
        <i class="fa fa-plus"></i>
      </button>
        <!-- <OffCanvas
      ref="offcanvas"
      v-model="showPanel"
      position="right"
      size="400px"
      :closeOnOverlay="true"
    >
      <template v-slot:header>
        <div style="display:flex;align-items:center;justify-content:space-between;width:100%">
          <h3 style="margin:0">Tambah Text Reply Baru</h3>
          <button class="btn" @click="$refs.offcanvas.close()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button> 
        </div>
      </template>

      <div> 
       <form-text-reply :searchData="updateData"/>
      </div>

       
    </OffCanvas> -->
    </div>
  </div>
</template>

<script>
import OffCanvas from "@/components/TextReply/offCanvas.vue";
import formTextReply from "@/components/TextReply/formTextReply.vue";  
export default {
  name: "textReply",
  components: {
    OffCanvas,
    formTextReply,
  },
  props: {
    value: {
      type: Object,
      default: () => ({ buttons: [] }),
    },
  },
  computed: {
    _myTabId() {
      return "tabA_" + Date.now() + "_" + Math.random().toString(36).slice(2);
    },
    selectedReplyID() {
      const buttons =
        this.formParam && Array.isArray(this.formParam.buttons)
          ? this.formParam.buttons
          : [];
      return buttons
        .map((item) => this.buttonId(item))
        .filter((id) => id !== "");
    },
    hasUnknownSelected() {
      if (this.textReplyLoading) {
        return false;
      }
      const buttons =
        this.formParam && Array.isArray(this.formParam.buttons)
          ? this.formParam.buttons
          : [];
      const rows = Array.isArray(this.textReplyRows) ? this.textReplyRows : [];
      return buttons.some((button) => {
        const id = this.buttonId(button);
        if (!id) return false;
        return !rows.some((row) => row.id === id);
      });
    },
    formParam: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value: {
      handler() {
        this.refreshButtonState();
      },
    },
    "formParam.buttons": {
      handler() {
        this.refreshButtonState();
      },
      deep: true,
    },
    textReplyRows() {
      this.refreshButtonState();
    },
  },
  beforeDestroy() {
    if (this.channel) this.channel.close();
  },
  data() {
    return {
      textReplyRows: [],
      textReplyLoading: true,
      textReplyLoadError: false,
      showTextReply: 3,
      showPanel: false,
      channel: null,
      lastIdxAddAction: null,
      openedWindowRef: null,
      defaultDetailTextReply: 10,
      textReplyParams: {
        columnFilters: {
          id: "",
          title: "",
          is_publish: "publish",
        },
        page: 1,
        perPage: 500, // perPage
      },
    };
  },
  created() {
    this.refreshButtonState();
  },
  mounted() {
    this.loadTextReply();
  },
  methods: {
    buttonId(button) {
      if (!button) return "";
      if (typeof button === "string") return button;
      return button.id || "";
    },
    ensureButtonsArray() {
      if (!this.formParam) return;
      if (!Array.isArray(this.formParam.buttons)) {
        this.$set(this.formParam, "buttons", []);
      }
    },
    normalizeSelectedButtons() {
      if (!this.formParam || !Array.isArray(this.formParam.buttons)) {
        return;
      }
      const rows = Array.isArray(this.textReplyRows) ? this.textReplyRows : [];
      this.formParam.buttons.forEach((button, index) => {
        if (button === "" || button === null || typeof button === "undefined") {
          return;
        }
        if (button === "__addNew") {
          this.$set(this.formParam.buttons, index, {
            id: "",
            button_text: "",
          });
          return;
        }
        if (typeof button === "string") {
          const row = rows.find((item) => item.id === button);
          this.$set(this.formParam.buttons, index, {
            id: button,
            button_text: row ? row.button_text || row.title || "" : "",
          });
          return;
        }
        if (!button.id) {
          if (button.button_text !== "") {
            this.$set(button, "button_text", "");
          }
          return;
        }
        const row = rows.find((item) => item.id === button.id);
        if (!row) {
          return;
        }
        const label = row.button_text || row.title || "";
        if (button.button_text !== label) {
          this.$set(button, "button_text", label);
        }
      });
    },
    ensureShowTextReply() {
      const count = this.selectedReplyID.length;
      if (count > this.showTextReply) {
        this.showTextReply = count;
      }
    },
    refreshButtonState() {
      this.ensureButtonsArray();
      this.normalizeSelectedButtons();
      this.ensureShowTextReply();
    },
    isUnknownSelected(index) {
      const buttons =
        this.formParam && Array.isArray(this.formParam.buttons)
          ? this.formParam.buttons
          : [];
      const id = this.buttonId(buttons[index - 1]);
      if (!id) return false;
      const rows = Array.isArray(this.textReplyRows) ? this.textReplyRows : [];
      return !rows.some((row) => row.id === id);
    },
    unknownButtonLabel(index) {
      const buttons =
        this.formParam && Array.isArray(this.formParam.buttons)
          ? this.formParam.buttons
          : [];
      const button = buttons[index - 1];
      if (!button) return "Text Reply tersimpan";
      let label =
        (typeof button === "object" && button.button_text) ||
        "Text Reply tersimpan";
      const id = this.buttonId(button);
      if (id) {
        label += " (" + id + ")";
      }
      return label;
    },
    checkAdd(el, i) {
      let val = el.target.value;
      if (val == "__addNew") {
        this.$set(this.formParam.buttons, i - 1, {
          id: "",
          button_text: "",
        });
        el.target.value = "";
        this.channel = this.$util.createChannel("member-type-channel");
        this.channel.on(this.onChannelMessage);
        this.lastIdxAddAction = i;
        this.openCrudTab();
      }
    },
    openCrudTab() {
      const requester = encodeURIComponent(this._myTabId);
      const url = `/automation/text-reply/list?action=add&requester=${requester}`;
      // buka new tab yang terkontrol
      this.openedWindowRef = window.open(
        this.$router.resolve(url).href,
        "_blank"
      );
      // opsional: fokus / store ref untuk fallback postMessage
    },
    onChannelMessage(msg) {
      // struktur pesan: { action: 'created'|'closed', requester: '<tabId>', data: {...} }
      if (!msg || !msg.requester) return;

      // Hanya tangani pesan yang ditujukan ke kita (msg.target may be 'all' or specific)
      // Jika requester di msg === myTabId -> artinya pesan dari tab yang kita buka
      if (msg.requester === this._myTabId) {
        if (msg.action === "created") {
          // data: { id, label, ... }
          // 1) reload list / atau push item optimistically
          this.loadTextReply(); // atau this.memberTypes.push(msg.data)
          // 2) set selected to new id
          // this.selectedType = msg.data.id;
          if (
            msg.data &&
            msg.data.isExit == 1 &&
            msg.data.data &&
            msg.data.data.id
          ) {
            this.$nextTick(() => {
              this.$set(this.formParam.buttons, this.lastIdxAddAction - 1, {
                id: msg.data.data.id,
                button_text: msg.data.data.title,
              });
              this.refreshButtonState();
            });
            this.channel.close();
          }
        } else if (msg.action === "closed") {
          // optional: fokus kembali ke page atau notif
          // nothing required
        }
      }
    },
    updateData() {
      this.loadTextReply();
      if (this.$refs.offcanvas) {
        this.$refs.offcanvas.close();
      }
      this.showPanel = false;
    },
    async loadTextReply() {
      this.textReplyLoading = true;
      this.textReplyLoadError = false;
      this.textReplyParams.page = 0;
      try {
        const response = await this.$store.dispatch(
          "automation/listTextReply",
          this.textReplyParams
        );
        const data = response && response.data ? response.data : {};
        this.textReplyRows = Array.isArray(data.data) ? data.data : [];
      } catch (error) {
        this.textReplyRows = [];
        this.textReplyLoadError = true;
        console.log(error);
      } finally {
        this.textReplyLoading = false;
        this.refreshButtonState();
      }
    },
  },
};
</script>
 


// WEBPACK FOOTER //
// src/views/broadcast/componentsV2/Forms/textReply.vue